import { IResponse } from "../types";
import {
  IAuthResponse,
  ILoginCodeResponse,
  IRegisterRequest,
  TLoginGoogleRequest,
  TLoginRequest,
  TLoginWithCodeRequest,
  TSendCodeRequest,
  TSendCodeWithoutLoginRequest,
} from "../types/auth.types";
import { TAnalyzeAudio, TVideoDiagnostics, TStartProcessingResponse } from "../types/user.types";
import { api } from "./api";

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<IAuthResponse, TLoginRequest>({
      query: ({ email, password, roleId }) => ({
        url: `user/login`,
        method: "POST",
        body: {
          email: email,
          password: password,
          roleId: roleId,
        },
      }),
    }),
    loginGoogle: build.mutation<IAuthResponse, TLoginGoogleRequest>({
      query: (body) => ({
        url: `user/login/google`,
        method: "POST",
        body,
      }),
    }),
    loginWithCode: build.mutation<ILoginCodeResponse, TLoginWithCodeRequest>({
      query: ({ phone, roleId, id }) => ({
        url: `user/code`,
        method: "POST",
        body: JSON.stringify({ phone, code: "0", roleId: roleId, usersId: id }),
      }),
    }),
    sendCodeWithoutLogin: build.mutation<
      ILoginCodeResponse,
      TSendCodeWithoutLoginRequest
    >({
      query: ({ phone, roleId }) => ({
        url: `user/codeWithoutLogin`,
        method: "POST",
        body: JSON.stringify({ phone, code: "0", roleId: roleId }),
      }),
    }),
    authWithoutLogin: build.mutation<
      IAuthResponse,
      TSendCodeWithoutLoginRequest
    >({
      query: (body) => ({
        url: `user/authWithoutLogin`,
        method: "POST",
        body,
      }),
    }),
    sendCode: build.mutation<IAuthResponse, TSendCodeRequest>({
      query: ({ code, roleId, usersId, email, password, phone }) => ({
        url: `user/authWithCode`,
        method: "POST",
        body: JSON.stringify({
          code,
          roleId,
          usersId,
          email,
          password,
          phone,
        }),
      }),
    }),
    logout: build.mutation<IResponse, string>({
      query: (refreshToken) => ({
        url: `/logout`,
        method: "POST",
        body: {
          token: refreshToken,
        },
      }),
    }),
    register: build.mutation<IAuthResponse, IRegisterRequest>({
      query: ({
        firstName,
        lastName,
        phone,
        passport,
        email,
        password,
        birth,
        degree,
      }) => ({
        url: `user/signup`,
        method: "POST",
        body: {
          firstName,
          lastName,
          phone,
          passport: passport.toString(),
          email,
          password,
          birth,
          degree,
        },
      }),
    }),
    // postRecord: build.mutation<
    //   TAnalyzeAudio,
    //   {
    //     file: File;
    //     type: number;
    //     usersId: string | number;
    //   }
    // >({
    //   query: ({ file, usersId, type = 5 }) => {
    //     const formData = new FormData();
    //     formData.append("file", file);
    //     const mediaType:string = "wav";
    //     return {
    //       url: `AI/analyzeMeetingRecord/${usersId}/${type}`,
    //       method: "POST",
    //       body: formData,
    //     };
    //   },
    // }),
    startProcessing: build.mutation<
      TStartProcessingResponse,
      {
        file: File;
        type: number;
        usersGuid: string;
      }
    >({
      query: ({ file, usersGuid, type = 5 }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: `MeetingRecords/startProcessing/${usersGuid}/${type}`,
          method: "POST",
          body: formData,
        };
      },
    }),
    restorePassword: build.mutation<IResponse, string>({
      query: (emailOrPhone) => ({
        url: `/restore_password`,
        method: "POST",
        body: {
          emailOrPhone,
        },
      }),
    }),
    verifySsoToken: build.mutation<IAuthResponse, string>({
      query: (token) => ({
        url: `user/validate/sso`,
        method: "POST",
        body: JSON.stringify(token),
      }),
    }),
    getTokenForAdmin: build.mutation<
      { code: string; success: boolean },
      void
    >({
      query: () => ({
        url: `user/switchRoleUserToken`,
        method: "POST",
      }),
    }),
    redeemSwitchCode: build.mutation<
      IAuthResponse,
      { code: string }
    >({
      query: ({ code }) => ({
        url: `user/redeemSwitchCode`,
        method: "POST",
        body: { code },
      }),
    }),
    SwitchCompanyUser: build.mutation<
      { accessToken: string; success: boolean },
      {guid: string, companyId: number}
    >({
      query: ({guid, companyId}) => ({
        url: `user/SwitchCompanyUserToken/${companyId}`,
        method: "POST",
        body: JSON.stringify(guid),
      }),
    }),
  }),
});

export const {
  useRestorePasswordMutation,
  useLoginGoogleMutation,
  useLoginWithCodeMutation,
  useSendCodeWithoutLoginMutation,
  useAuthWithoutLoginMutation,
  useLoginMutation,
  useVerifySsoTokenMutation,
  useGetTokenForAdminMutation,
  useRedeemSwitchCodeMutation,
  useSwitchCompanyUserMutation,
  // usePostRecordMutation,
  useStartProcessingMutation
} = authApi;
